import { apiSlice } from "../../app/api/apiSlice";

export const servicesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createRepairOrder: builder.mutation({
      query: (orderData) => ({
        url: '/services/repair',
        method: 'POST',
        body: orderData,
      }),
    }),
  }),
});

export const {
  useCreateRepairOrderMutation,
} = servicesApiSlice;